import {CERT_PROP_NAME} from 'common/constants';

export const SslKeyNames = {
   filepath: CERT_PROP_NAME,
   certName: 'certName',
   overwrite: 'overwrite',
   folderID: 'folderID',
   passphrase: 'passphrase',
};
